import { render, staticRenderFns } from "./FormAdmin.vue?vue&type=template&id=de6ebfde&"
import script from "./FormAdmin.vue?vue&type=script&lang=js&"
export * from "./FormAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports